import { tokens } from 'src/design-system';

export const RfqBidsStyles = () => ({
  noBid: {
    color: tokens.colors.error,
    fontSize: tokens.fontSize.small,
  },
  radioGroup: {
    display: 'block',
    width: '100%',
  },
  radio: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    marginRight: 0,
    // Ant Design puts the Radio label content in the trailing span; let it fill the row.
    '& > span:last-child': {
      flex: 1,
      paddingRight: 0,
    },
  },
  changeSelection: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: tokens.spacing.sm,
  },
  clearSelectionButton: {
    padding: 0,
    height: 'auto',
    fontSize: tokens.fontSize.body,
    color: tokens.colors.primary,
  },
});
